module.exports = __webpack_public_path__ + "img/dsci0029.1978384f.jpg";